<template>
  <div class="childtrackingsystem-groupoverview">
    <div
      v-if="isLoading"
      class="row bg-white"
    >
      <div class="col-12 text-center">
        <img
          src="../../assets/img/loading.gif"
          alt="Loading"
          style="width: 80px; height: 80px;"
        >
      </div>
    </div>

    <div class="row bg-white pt-3 pb-1">
      <div class="col-md-4">
        <label
          for="age"
          class="form-label"
        >Leeftijd</label>
        <input
          type="search"
          class="form-select form-select-sm"
          id="age"
          placeholder="Zoek..."
          name="age"
          list="ages-list"
          v-model="searchedAge"
          @focus="searchedAge = ''; document.getElementById('ages-list').style.display='block';"
          @change="searchResults()"
        />
        <datalist id="ages-list">
          <option value="Alle" selected></option>
          <option
            v-for="age in ages"
            :value="age.description"
            :key="age.id"
          >
          </option>
        </datalist>
      </div>
      <div class="col-md-4">
        <label
          class="form-label"
          for="selectedList"
        >Observatielijst</label>
        <input
          type="search"
          class="form-select form-select-sm"
          id="selectedList"
          placeholder="Zoek..."
          name="selectedList"
          list="lists-list"
          v-model="searchedList"
          @focus="searchedList = ''; document.getElementById('lists-list').style.display='block';"
          @change="searchResults()"
        />
        <datalist id="lists-list">
          <option value="Alle" selected></option>
          <option
            v-for="list in lists"
            :key="list.id"
            :value="list.titel"
          >
          </option>
        </datalist>
      </div>
      <div class="col-md-4">
          <label
            for="filterChildren"
            class="form-label"
          >Ontwikkelingsgebied</label>
          <input
            type="search"
            class="form-select form-select-sm"
            id="idCategory"
            placeholder="Zoek..."
            name="idCategory"
            list="categories-list"
            v-model="searchedCategory"
            @focus="searchedCategory = ''; document.getElementById('categories-list').style.display='block';"
            @change="searchResults()"
          />
          <datalist id="categories-list">
            <option value="Alle" selected></option>
            <option
              v-for="category in categories"
              :key="category.id_kindvolgsysteem_ontwikkeling_categorieen"
              :value="category.ontwikkeling_categorie"
            >
            </option>
          </datalist>
        </div>
    </div>
    <div class="row bg-white pt-1 pb-3">
      <div class="col-md-4">
        <label
          for="mentor"
          class="form-label"
        >Invuller</label>
        <input
          type="search"
          class="form-select form-select-sm"
          id="mentor"
          placeholder="Zoek..."
          name="mentor"
          list="mentors-list"
          v-model="searchedMentor"
          @focus="searchedMentor = ''; document.getElementById('mentors-list').style.display='block';"
          @change="searchResults()"
        />
        <datalist id="mentors-list">
          <option value="Alle" selected></option>
          <option
            v-for="mentor in mentors"
            :value="mentor.name"
            :key="mentor.id"
          >
          </option>
        </datalist>
      </div>
      <div class="col-md-4">
        <label
          for="filterChildren"
          class="form-label"
        >Filter kinderen</label>
        <select
          class="form-select form-select-sm"
          id="filterChildren"
          name="filterChildren"
          v-model="filterChildren"
          @change="getResults()"
        >
          <option value="all">Alle</option>
          <option value="present">Aanwezig</option>
          <option value="vve">VVE</option>
        </select>
      </div>
    </div>

    <div
      v-if="!isResults"
      class="row bg-white pt-5 pb-5"
    >
      <div class="col-md-12 alert alert-danger">
        <span class="ps-2 pt-2 pb-2">Kies een observatielijst om het groepsoverzicht te zien</span>
      </div>
    </div>
    <div
      class="row bg-white"
      v-for="(result, rIdx) in results"
      :key="rIdx"
    >
      <div class="col-12">
        <table
          style="width:100%; overflow: auto; border-collapse: inherit; border-spacing: 0 10px;"
          v-for="(category, cIdx) in result.categories"
          :key="cIdx"
        >
          <tr class="preHeader">
            <td
              style="width: 800px;"
              @click="showContent(category.idCategory)"
            >
                  <span :style="'color:' + category.color + ';padding-left:15px;'">
              {{ category.category }}
            </span>
            </td>
            <td
              v-for="(child, childIdx) in category.children"
              :key="childIdx"
              style="width:150px;vertical-align: top;"
            >
              <span :title="child.full_name">{{ child.shortName }}</span> <br>
              ({{ child.ageChild }} mnd)
            </td>
          </tr>
          <tbody
            :id="'content-'+category.idCategory"
            class="d-none"
          >
            <tr
              class="bg-white borderBottomShadow"
              v-for="(question, qIdx) in category.questions"
              :key="qIdx"
              style="border-bottom: 1pt solid #666;"
            >
              <td
                class="borderBottomShadow"
                style="width: 800px;padding-left:15px;"
              ><span v-if="question.subcategory"><b>{{ question.subcategory }}:</b> </span>{{ question.question }}
              </td>
              <td
                class="borderBottomShadow"
                v-for="(answer, aIdx) in question.answers"
                :key="aIdx"
                style="width:150px;text-align: center;"
              >
                <div
                  :style="'border-radius: 50%;width:25px;height:25px;background-color:' + answer.color + ';color:' + answer.color"
                  :title="answer.date"
                ></div>
              </td>
            </tr>
          </tbody>
          <tr style="height: 50px;">
            <td style="width: 800px;"><b>Gem. score</b></td>
            <td
              v-for="(child, childIdx) in category.children"
              :key="childIdx"
              style="width:150px;"
            >
              {{ child.score }} / {{ child.totalScore }}
            </td>
          </tr>
        </table>
        <br><br>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'childtrackingsystem-groupoverview',
  components: {},
  data() {
    return {
      isLoading: false,
      results: [],
      ages: [],
      selectedAge: 0,
      searchedAge: 'Alle',
      selectedCategory: 0,
      searchedCategory: 'Alle',
      categories: [],
      lists: [],
      selectedList: 0,
      searchedList: 'Alle',
      filterChildren: 'all',
      mentors: [],
      searchedMentor: 'Alle',
      selectedMentor: 0,
      isResults: false
    };
  },
  computed: {
    deviceToken() {
      return this.$store.getters.deviceToken;
    },
    session() {
      return this.$store.getters.session;
    }
  },
  created() {
    window.novict = {
      device: {
        device_token: this.deviceToken
      },
      session: {
        session_token: this.session.session_token
      }
    };
    this.getResults()
  },
  methods: {
    getResults() {
      this.isLoading = true;
      this.$store.commit('REGISTER_ACTIVE_REQUEST');
      this.$request.post('/ChildTrackingSystem/groupOverview', {
        idEstablishment: this.$store.getters.selectedEstablishment.id,
        idGroup: this.$store.getters.selectedGroupsQueryString,
        idAge: this.selectedAge,
        idList: this.selectedList,
        idMentor: this.selectedMentor,
        idCategory: this.selectedCategory,
        filterChildren: this.filterChildren
      }).then((response) => {
        this.isLoading = false;
        this.$store.commit('REMOVE_ACTIVE_REQUEST');
        this.results = response.results
        this.ages = response.ages
        this.lists = response.lists
        this.categories = response.categories
        this.mentors = response.mentors
        this.isResults = !!(this.selectedList && this.results.length > 0);
      });
    },
    showContent(idCategory) {
      let elem = document.getElementById('content-' + idCategory);
      if (elem.classList.contains('d-none')) {
        elem.classList.remove('d-none');
      } else {
        elem.classList.add('d-none');
      }
    },
    searchResults() {
      if (this.searchedMentor === 'Alle') {
        this.selectedMentor = 0
      } else {
        this.mentors.forEach(mentor => {
          if (mentor.name.toLowerCase().includes(this.searchedMentor.toLowerCase())) {
            this.selectedMentor = mentor.id
          }
        })
      }
      if (this.searchedAge === 'Alle') {
        this.selectedAge = 0
      } else {
        this.ages.forEach(age => {
          if (age.description.toLowerCase().includes(this.searchedAge.toLowerCase())) {
            this.selectedAge = age.id
          }
        })
      }
      if (this.searchedList === 'Alle') {
        this.selectedList = 0
      } else {
        this.lists.forEach(list => {
          if (list.titel.toLowerCase().includes(this.searchedList.toLowerCase())) {
            this.selectedList = list.id
          }
        })
      }
      if (this.searchedCategory === 'Alle') {
        this.selectedCategory = 0
      } else {
        this.categories.forEach(category => {
          if (category.ontwikkeling_categorie.toLowerCase().includes(this.searchedCategory.toLowerCase())) {
            this.selectedCategory = category.id_kindvolgsysteem_ontwikkeling_categorieen
          }
        })
      }
      document.activeElement.blur()
      this.getResults()
    }
  }
};
</script>
<style scoped>
.preHeader {
  color: #445161;
  background-color: #dedee7;
}

.borderBottomShadow {
  border-bottom: 1px #ddd solid;
}

</style>